<template>
  <div class="mypage">
    <Loading v-show="loading"></Loading>
    <div id="mypage-inner">
      <img  id="icon" src="../../assets/defaultUser.png">
    <p class="name" style="text-align: center;">{{ name }}</p>
    <button id="todayRecipeButton" type="" v-on:click="todayRecipe()">本日のレシピを確認</button>
    <div class="updatePop" v-show="isUpdateModal">
      <img v-on:click="close()" id="updatePop" class="close-btn" src="../../assets/close.png" width="36px" height="36px" style=" position: absolute; top:8px; right: 8px;">
      <h2 style="text-align:center;">アカウント情報の修正</h2>
      <p class="description">{{ selectDescription }} </p>
      <table>
        <tbody>
          <tr>
            <td><p class="pop-title">{{ selectTitle }}</p></td>
            <td>
              <input v-model="value" id="memo" name="memo">
            </td>
          </tr>
        </tbody>
      </table>
      <button  v-show="isUpdateButton" v-on:click="updateUserClass()" id="update" class="pop-button">変更</button>
      <button  v-show="isSendButton" v-on:click="sendMail()" id="update" class="pop-button">送信</button>
    </div>
    <div id="tab">
      <ul class="tabMenu">
        <li class="tabItem" v-for="(tab,index) in tabs" v-on:click="activetab=(index+1)" v-bind:class="[ activetab === (index+1) ? 'active' : '' ]">{{tab.tabitem}}</li>
      </ul>
      <div class="account-inner" v-if="activetab === 1">
        <p class="title">アカウント情報</p>
        <table>
          <tr>
            <th colspan="2"><p class="title">ユーザーネーム</p></th>
          </tr>
          <tr>
            <td><p class="value">{{ name }}</p></td>
            <td style="text-align: right;"><button v-on:click="updateUser(0)">変更する</button></td>
          </tr>
          <tr>
            <th colspan="2"><p class="title">メールアドレス</p></th>
          </tr>
          <tr>
            <td><p class="value">{{ mail }}</p></td>
            <td style="text-align: right;"><button v-on:click="updateUser(1)">変更する</button></td>
          </tr>
          <tr>
            <th colspan="2"><p class="title">パスワード</p></th>
          </tr>
          <tr>
            <td><p class="value">{{ password }}</p></td>
            <td style="text-align: right;"><button v-on:click="updateUser(2)">変更する</button></td>
          </tr>
          <!--
          <tr>
            <th colspan="2"><p class="title">Instagramユーザーネーム</p></th>
          </tr>
          <tr>
            <td><p class="value">{{ instaname }}</p></td>
            <td style="text-align: right;"><button v-on:click="updateUser(3)">変更する</button></td>
          </tr>-->
        </table>
        <div class="charge-inner">
          <p class="title">決済設定</p>
          <p class="charge-text">セキュリティーの関係で表示しません、確認・変更したい方はカードを確認・変更するボタンからご確認ください。</p>
          <div class="button-contents">
              <button v-on:click="check()" id="check">カードを確認・変更する</button>
          </div>
        </div>
        <div class="broadcastInner">
          <p class="title">配信設定</p>
          <!--<button id="broadcastWay" v-on:click="updateUser(4)">変更する</button>-->
        </div>
        <table>
          <tr>
            <th colspan="2"><p class="title">配信内容</p></th>
          </tr>
          <tr>
            <td colspan="2"><p class="value">本日レシピ</p></td>
          </tr>
          <tr>
            <th colspan="2"><p class="title">配信形式</p></th>
          </tr>
          <tr>
            <td colspan="2"><p class="value">Instagram(登録されたメールにも配信致します。)</p></td>
          </tr>
        </table>
        <div class="button-contents" style="padding:5%;">
            <a id="instagramButton" type="" href="/connectSetting">Instagramの通知設定がお済みでない方はこちら</a>
        </div>

        <!--
        <div class="flexbox">
          <section class="main">
            <div class="button-contents" style="padding:5%;">
              <a id="instagramButton" type="" href="">Instagramタイムラインでレシピを<br>確認する方はこちら</a>
            </div>
          </section>
          <section class="side">
            <div class="button-contents" style="padding:5%;">
              <a id="lineButton" type="" href="https://lin.ee/gfRrd5w">Lineタイムラインでレシピを<br>確認する方はこちら</a>
            </div>
          </section>
        </div>-->
        <a id="deleteUserButton" v-on:click="resign()">退会はこちら</a>
      </div>
      <div class="form" v-else>
        <div class="search-inner"><input v-on:keydown.enter="search" v-model="searchText" placeholder="お気に入りしたレシピを検索する" id="search-box"></div>
        <div class="recipes">
          <div class="flexbox">
            <div class="item" v-for="recipe of searchRecipes"  :key="recipe">
              <img v-bind:src="recipe.thumbnail" alt="" />
              <p>{{ recipe.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="charge-confirmation-pop" v-show="isConfirmationModal">
      <img v-on:click="close()" class="close-btn" src="../../assets/close.png" width="36px" height="36px" style=" position: absolute; top:8px; right: 8px;">
      <h2 style="text-align:center;">お客様のカード情報</h2>
      <table>
        <tbody>
          <tr>
            <td class="pop-title">ブランド</td>
            <td>
              <p class="pop-value">{{ brand }}</p>
            </td>
          </tr>
          <tr>
            <td class="pop-title">カード番号：</td>
            <td><p class="pop-value">✖︎✖︎✖︎✖︎　✖︎✖︎✖︎✖︎　{{ number }}</p></td>
          </tr>
          <tr>
            <td class="pop-title">使用期限日：</td>
            <td><p class="pop-value">{{ limitDate }}</p></td>
          </tr>
        </tbody>
      </table>
      <button  v-on:click="changeCard()" id="update" class="pop-button">カードを変更する</button>
    </div>
  </div>
</template>
<style scoped>
  #todayRecipeButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:16px auto;
  border:0px;
}
.mypage img{
  width: 200px;
  height: 200px;
  margin-top: 0px;
  margin-bottom: 0px;
  object-fit: cover;
}
.mypage .updatePop img{
  width: 24px;
  height: 24px;
}
*{
  box-sizing: border-box;
}
#mypage-inner{
  margin-top: 5%;
  margin-bottom: 5%;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
#tab{
  max-width: 100%;
  margin: 5% auto;
}

.tabMenu{
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  list-style: none;
  border-bottom: 1px solid black;
  width: 40%;
  margin: auto;
}
.account-inner{
  max-width: 40%;
  margin: 5% auto;

}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.tabItem.active{
  background-color: black;
  color: #fff;
}
#instagramButton{
  display: block;
  background:#CF2E92;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 12px;
  margin:16px auto;
  border:0px;
}
#lineButton{
  display: block;
  background:#1dcd00;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 12px;
  margin:16px auto;
  border:0px;
}
#deleteUserButton{
  background: red;
  color: white;
  border:0px;
  display: block;
  width: 50%;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 12px;
  margin:16px auto;
  border:0px;
}
.description {
  font-style: normal;
  font-family: Hiragino Kaku Gothic Pro;
  margin-left: 5%;
  margin-right: 5%;
  text-align: left;
}
table .title{
  text-align: left;
}
table td{
  width: 50%;
}
table {
  width: -webkit-fill-available;
  padding-left: 5%;
}
table .value{
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  font-family: Hiragino Kaku Gothic Pro;
}
table button{
  background: transparent;
  color: orange;
  border:0px;
}
#check{
  background: transparent;
  color: orange;
  border:0px;
}
.broadcastInner{
  position: relative;
  margin-top: 20%;
}
.broadcastInner button{
  position: absolute;
  top:0px;
  right: 0px;
   border:0px;
  background: transparent;
  color: orange;
}
.search-inner{
  background: #CCCCCC;
}
.search-inner input{
  width: 40%;
  margin-top: 36px;
  margin-bottom: 36px;
  border-radius: 10px;
  font-size: 20px;
  padding: 8px;
  border:0px;
  
}
.flexbox section{
    width: 100%;
    display: block;
    margin: auto;
}
.charge-inner{
  position: relative;
}
.charge-inner .button-contents{
  position: absolute;
  top: 0px;
  right: 0px;

}
.charge-text{
  position: absolute;
  font-style: normal;
  font-family: Hiragino Kaku Gothic Pro;
  margin-left: 5%;
  margin-right: 5%;
  text-align: left;
}
.charge-confirmation-pop{
  position: fixed;
  z-index: 10;
  height: auto;
  background: white;
  left: 30%;
  top: 20%;
  transition: .6s;
  box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.4);
  width: 40%;
}

.charge-confirmation-pop img{
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;

}
.charge-confirmation-pop table{
  width: 80%;
  margin: 0 auto;
  border: 0px solid #dadce0;
  }
  .charge-confirmation-pop tr, td{
    border: 0px solid #dadce0;
  }
  .charge-confirmation-pop .pop-title{
    text-align: left;
  }
  .charge-confirmation-pop .pop-value {
    text-align: left;
    font-family: Hiragino Kaku Gothic Pro;
  }
  .charge-confirmation-pop .pop-button{
    width: 50%;
    margin-top: 16px;
    margin-bottom: 16px;
    background: #FF9900;
    color:white;
    border: 0px solid #dadce0;
    border-radius: 50px 50px 50px 50px;
  }
  .charge-confirmation-pop .pop-button:hover{
    width: 50%;
    margin-top: 16px;
    margin-bottom: 16px;
    background: #FF9966;
    color:white;
    border: 0px solid #dadce0;
    border-radius: 50px 50px 50px 50px;
  }
@media ( max-width : 600px ){
  #icon{
    width: 100px;
    height: 100px;
  }
  #mypage-inner .name {
    font-size: 24px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
   #todayRecipeButton{
  font-size: 20px;
  width: 80%;
}
#tab{
  max-width: 100%;
  margin: 5% auto;
}
table {
  width: 90%;
  padding-left: 5%;
}
table .value{
  font-size: 16px;
}
.account-inner{
  max-width: 100%;
  margin: 5% auto;

}
.tabMenu{
  width: 100%;
  margin: auto;
}
.search-inner input {
    width: 80%;
}
.flexbox {
    display: flex;
    flex-wrap: wrap;
    padding-top: 5%;
    padding-bottom: 5%;
}
  .item {
    width: 50%;
  }
}
.item {
  border-radius: 10px;
  text-align: center;
}
.recipes {
  width: 80%;
  margin:0 auto;
}
.recipes img {
  width: 100%;
  height: auto;
  border-radius: 20px;
}
p {
  text-align: center;
}
.updatePop{
  position: fixed;
  z-index: 10;
  height: auto;
  background: white;
  left: 5%;
  top: 20%;
  transition: .6s;
  box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.4);
  width: 90%;
}
.charge-confirmation-pop{
  position: fixed;
  z-index: 10;
  height: auto;
  background: white;
  left: 5%;
  top: 20%;
  transition: .6s;
  box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.4);
  width: 90%;
}
.close-btn {
  position: absolute;
  right: 0;
  top: 0;
  width: 36px;
  height: 36px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.updatePop table{
  width: 80%;
  margin: 0 auto;
  border: 0px solid #dadce0;
  }
  .updatePop tr, td{
    border: 0px solid #dadce0;
  }
  .updatePop .pop-title{
    text-align: left;
  }
  .updatePop .pop-button{
    width: 50%;
    margin-top: 16px;
    margin-bottom: 16px;
    background: #FF9900;
    color:white;
    border: 0px solid #dadce0;
    border-radius: 50px 50px 50px 50px;
  }
  .updatePop .pop-button:hover{
    width: 50%;
    margin-top: 16px;
    margin-bottom: 16px;
    background: #FF9966;
    color:white;
    border: 0px solid #dadce0;
    border-radius: 50px 50px 50px 50px;
  }
@media ( min-width : 600px ){
.flexbox {
    display: flex;
    flex-wrap: wrap;
}
  .item {
    width: 33%;
    padding: 36px;
  }
}
@media ( max-width:  : 780px ){
}

</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Mypage',
  components: {
    Loading
  },
  data () {
    return {
      userId: null,
      db: null,
      isUpdateModal: false,
      isUpdateButton: false,
      isSendButton: false,
      loading: false,
      name: null,
      mail: null,
      customerId: null,
      popTitle: null,
      password: null,
      instaname: null,
      broadcastContent: null,
      broadcastWay: null,
      activetab: 1,
      searchText: null,
      recipes: [],
      userRecipes: [],
      searchRecipes: [],
      selectType: null,
      selectTitle: null,
      selectDescription: null,
      value: null,
      isConfirmationModal: false,
      brand: null,
      number: null,
      limitDate: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/,
      tabs: [
      { tabitem: "ホーム" },
      { tabitem: "お気に入りレシピ" }
    ],
    contents: [
      {
        position: 0
      },
      {
        position: 1
      }
    ]
    }
  },
  methods: {
    search: function () {
      console.log('検索する文字-------------')
      console.log(this.searchText)
      // 検索する文字が名前に存在するもののみ表示、
      const recipe = this.userRecipes.filter(r => r.name.includes(this.searchText))
      console.log(recipe)
      if (!recipe) {
        alert('一致するものがありませんでした。全件表示いたします。')
        this.searchRecipes = this.userRecipes
      } else {
        this.searchRecipes = recipe
      }
    },
    check: function () {
      // 11/30(月) 決済情報取得＆表示&修正機能
      // 退会機能
      let self = this
      self.loading = true
      var data = {'id': this.customerId}
              $.ajax({
                url: 'https://weart-marketing.com/api/7200kcal/getCustoerInformation/',
                type: 'POST',
                data: data
              })
              .done(function (data) {
                console.log('AAAAAAAAAAAAAAa')
                console.log(data)
                console.log('AAAAAa')
                self.loading = false


                var dataArray = data.split(',');
        
                // 決済のカード確認・変更のダイアログ
                self.isConfirmationModal = true
                self.brand = dataArray[0]
                self.number = dataArray[3]
                self.limitDate = dataArray[2] + '年' + dataArray[1] + '月'

              })
              .fail(function (error) {
                self.loading = false
                alert('カード情報取得を失敗しました。運営会社にお問い合わせください。')
              })

    },
    changeCard: function () {
      location.href = '/confirmMailForChangeCard?mail=' + this.mail + '&userId=' + this.userId
    },
    changePlan: function () {
    },
    resign: function () {
      location.href = '/resign?userId=' + this.userId
    },
    close: function () {
      this.isUpdateModal = false
      this.isConfirmationModal = false
    },
    sendMail: function () {


      // メール・パスワードで条件分岐
      var url = null
      if (this.selectType === 1) {
        url = 'https://asia-northeast1-kcal-27d27.cloudfunctions.net/sendConfirmationForChangeMail'
      }
      if (this.selectType === 2) {
        url = 'https://asia-northeast1-kcal-27d27.cloudfunctions.net/sendConfirmationForChangePassword'
      } 

      console.log('cbakscascascvdveve')
      console.log(url)
      console.log('cbakscascascvdveve')

      if (!this.value) {
        alert('メールアドレスの入力をしてから送信ボタンを押しましょう')
        return
      }
      //メールアドレスのバリデーション
      if (!this.mailPattern.test(this.value)) {
        alert('メールアドレスの入力が正しくありません。')
        return
      }


      

      let self = this
      self.loading = true
      var exist = false
      this.db.collection('users').where('mail', '==', this.value).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          exist = true
          var data = { 'mail': self.value, 'userId': self.userId}
          $.ajax({
            url: url,
            type: 'GET',
            data: data
          })
            .done(function (data) {
              self.isUpdateModal = false
              self.loading = false
              alert('メール送信に成功しました。届いたメールから変更手続きを進めてください。')
            })
            .fail(function () {
              self.isUpdateModal = false
              self.loading = false
              alert('メール送信に失敗しました。再度、実行してください。')
            })
        })
        if (!exist) {
          alert('入力されたメールアドレスを持つユーザーは存在しません。ID・パスワードを忘れた方は「忘れた方はこちら」からお問い合わせください。')
          self.loading = false
          return
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('送信に失敗しました。エラーです。')
          self.loading = false
          return
        })

    },
    sendMessage: function () {
      
    },
    updateUser: function (type) {
      console.log(type)
      this.selectType = type
      switch (type) {
        case 0:
          this.isUpdateButton = true
          this.isSendButton = false
          this.selectTitle = "ユーザーネーム"
          this.selectDescription = "ユーザーネームを変更するには、名前を修正後、変更ボタンを押してください。"
          this.value = this.name
          this.isUpdateModal = true
          break;
        case 1:
          this.isUpdateButton = false
          this.isSendButton = true
          this.selectTitle = "メールアドレス"
          this.selectDescription = "メールアドレスを変更するには、二段階認証が必要です。ご登録頂いたメールアドレスをご入力ください。入力して頂いた宛先にパスコードと認証URLが届きますので、そちらで再度認証を完了してから新しいメールアドレスへの変更の手続きをお願いいたします。"
          this.value = ""
          this.isUpdateModal = true
          // this.selectTitle = "メールアドレス"
          // this.value = this.mail
          break;
        case 2:
          this.isUpdateButton = false
          this.isSendButton = true
          this.selectTitle = "メールアドレス"
          this.selectDescription = "パスワードを変更するには、二段階認証が必要です。ご登録頂いたメールアドレスをご入力ください。入力して頂いた宛先にパスコードと認証URLが届きますので、そちらで再度認証を完了してから新しいメールアドレスへの変更の手続きをお願いいたします。"
          this.value = ""
          this.isUpdateModal = true
          break;
        case 3:
          this.isUpdateButton = true
          this.isSendButton = false
          this.selectTitle = "Instagramユーザーネーム"
          this.selectDescription = "Instagramユーザーネームを変更するには、名前を修正後、変更ボタンを押してください。"
          this.value = this.instaname
          this.isUpdateModal = true
          break;
        case 4:
          alert('現在仕様決定中')
          break;
  
      }
    },
    updateUserClass: function () {
      let self = this
      // 入力を確認
      switch (this.selectType) {
        case 0:
            // バリデーション
            if (!this.value) {
              alert('変更する名前を入力してから、保存ボタンを教えてください。')
              break
            }
            self.loading = true


            // PayJPの顧客情報の名前・メールアドレスを変更
            var data = {'id': this.customerId, 'name': this.value}
              $.ajax({
                url: 'https://weart-marketing.com/api/7200kcal/updateDescription/',
                type: 'POST',
                data: data
              })
              .done(function (data) {
                console.log('顧客情報')
                console.log(data)
                console.log('debfdkejwudewud')
                self.update()
              })
              .fail(function (error) {
                self.loading = false
                alert('ユーザー情報の変更に失敗しました、再度お手続きをお願い致します。')
              })

          break;
        case 4:
        　console.log('現在ここは仕様未決定')
          break;
      }




    },
    update: function () {
      // Userクラスへ更新処理
      let self = this
      const docRef = this.db.collection('users').doc(this.userId)
              docRef.update({
                name: this.value}).then(function () {
                      self.isUpdateModal = false
                      alert('アカウント情報の更新に成功しました。')
                      self.recipes = []
                      self.userRecipes = []
                      self.searchRecipes = []
                      self.getRecipes()
                      self.loading = false
                    }).catch(function () {
                      alert('アカウント情報の更新に失敗しました。再度、実行してください。')
                      self.loading = false
                      self.isUpdateModal = false
                    })
    },
    getRecipes: function () {
      let self = this
      var recipeNum = 0
      let recipeCollection = this.db.collection('recipes')
      recipeCollection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var hash = {}
          hash['id'] = doc.id
          hash['name'] = doc.get('name')
          hash['thumbnail'] = doc.get('thumbnail')
          self.recipes.push(hash)
          if (recipeNum === querySnapshot.docs.length - 1) {
            self.getUserInformation()
          }
          recipeNum++
        })
      })
    },
    getUserInformation: function () {
      let self = this
      var docRef = this.db.collection("users").doc(this.userId)
      docRef.get().then(function(doc) {
          if (doc.exists) {
              self.name = doc.get('name')
              self.mail = doc.get('mail')
              self.password = doc.get('password')
              if (!doc.get('account')) {
                self.instaname = 'ーーーー'
              } else {
                self.instaname = doc.get('account')
              }
              self.customerId = doc.get('customer')
              /*
              if (!doc.get('broadcastContent')) {
                self.broadcastContent = '本日レシピ/2700KcalNews'
              } else {
                switch (doc.get('broadcastContent')) {
                  case 0:
                    self.broadcastContent = '本日レシピ/2700KcalNews'
                    break
                  case 1:
                    self.broadcastContent = '本日レシピ'
                    break
                  default:
                    self.broadcastContent = '本日レシピ'
                }
              }
              if (!doc.get('broadcastWay')) {
                self.broadcastWay = 'Instagram/Line/DM'
              } else {
                switch (doc.get('broadcastWay')) {
                  case 0:
                    self.broadcastWay = 'Instagram/Line/DM'
                    break
                  case 1:
                    self.broadcastWay = 'Instagram/DM'
                    break
                  default:
                    self.broadcastWay = 'Line/DM'
                }
              }*/
              console.log('こちらでお気に入りメニュー取得')
              console.log(doc.get('recipes'))
              console.log('dqwidgqwiudgqwdgqwyudqw')
              if (doc.get('recipes')) {

                var recipeNum = doc.get('recipes').length
                doc.get('recipes').forEach(function(recipeId){
                  console.log(recipeId)
                  const recipe = self.recipes.find(r => r.id === recipeId)
                  console.log(recipe)
                  console.log("dqwkdbqwhudiqw")
                  var hash = {}
                  if (!recipe) {
                    hash['id'] = '1a1a1a'
                    hash['name'] = 'レシピメニューに存在しません。'
                    hash['thumbnail'] = '画像なし'
                  } else {
                    hash['id'] = recipe.id
                    hash['name'] = recipe.name
                    hash['thumbnail'] = recipe.thumbnail
                  }
                  self.userRecipes.push(hash)
                  self.searchRecipes.push(hash)
                })

                self.getStorageURL()

              }
          } else {
              alert('ユーザーが存在しません、。再度ログインしなおしてください。')
              localStorage.userId = ''
              location.href='/'
          }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      })
    },
    getStorageURL: function () {

      let self = this
      for(let i =0;i < self.searchRecipes.length; i++){ 
        var ref = firebase.storage().ref().child(self.searchRecipes[i].thumbnail)
          ref.getDownloadURL().then((url) => {
            console.log(url)
            self.searchRecipes[i].thumbnail = url
        });
      }

    },
    todayRecipe: function () {
       location.href='/today?startYear=' + (new Date()).getFullYear() + '&startMonth=' + (new Date()).getMonth() + '&startDate=' + (new Date()).getDate() + '&userId=' + this.userId
    }
  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    firebase.auth().languageCode = 'jp'
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.userId = result['userId']
    if (!this.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    } else {
      if (!localStorage.userId) {
        alert('ログイン認証が外れました。再度ログインしてからマイページにアクセスしてください。')
        location.href='/'
      } else {
        this.getRecipes()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mypage/Mypage.vue